import { GeofencesDef, type GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const cluster = css`
  display: flex;
  flex: 1;
  max-width: 80px;
  width: fit-content;
  min-width: 40px;
  padding: 3px;
  border-radius: 10px;
  color: ${colors.white.DEFAULT};
  height: 20px;
  background: ${colors.black.DEFAULT};
  border: 1px solid ${colors.gray[5]};
  font-weight: ${fontWeight.medium};
  filter: drop-shadow(
    0px 4px 4px ${colors.gray.a4}
  );
  transform: translateX(-50%);
  align-items: center;
  cursor: pointer;
  padding-right: 6px;

  & > div {
    min-width: 14px;
    text-align: center;
  }
`;

export const pinContainer = (type?: GeofenceType) => css`
  color: ${type ? GeofencesDef[type].cssColor : colors.gray.dark};

  svg {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    margin-top: -5px;
  }
`;
